import { useCashSession } from "./useCashSession";
import { useCashSummary } from "./useCashSummary";
import { useCashWithdrawal } from "./useCashWithdrawal";
import { useCashReport } from "./useCashReport";
import { useCashMovements } from "./useCashMovements";
import { useCashIncome } from "./useCashIncome";
import { useCashCount } from "./useCashCount";
import { useCashAdjustment } from "./useCashAdjustment";

export const useCashReset = () => {

  const {
    clearActiveSession,
    resetOpeningAmountAndDetails,
    stopCounting
  } = useCashSession();

  const { clear: clearSummary } = useCashSummary();
  const { clear: clearWithdrawal } = useCashWithdrawal();
  const { clear: clearIncome } = useCashIncome();
  const { clear: clearReport } = useCashReport();
  const { clear: clearMovements } = useCashMovements();
  const { reset: resetCount } = useCashCount();
  const { clear: clearAdjustment } = useCashAdjustment();

  const resetCashFlow = () => {

    // 🧠 detener procesos
    stopCounting();

    // 🧠 limpiar UI
    resetOpeningAmountAndDetails();
    clearWithdrawal();
    clearIncome();
    clearAdjustment();

    // 🧠 limpiar arqueo
    resetCount();

    // 🧠 limpiar sesión
    clearActiveSession();

    // 🧠 limpiar data derivada
    clearSummary();
    clearReport();
    clearMovements();

  };

  return {
    resetCashFlow
  };

};